/**
 * Wrap the given function in a function that does not pass through calls until after a delay of X (wait).
 *
 * @param {function} func The function to wrap
 * @param {number} wait The milliseconds to wait
 * @returns {Function} The wrapped function
 */
const debounce = (func, wait) => {
	let timeout;
	
	return function() { // Needs to be traditional function to capture context
		const args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
};

export default debounce;



// WEBPACK FOOTER //
// ./src/debounce.js